module.exports = __webpack_public_path__ + "img/plant.9a87e9a7.jpg";